<template>
    <div class="contact_us">
    <img
      src="../assets/contactus/banner.png"
      alt
      style="width: 100%; height: 13.125rem"
    />
     <h3>{{msg}}</h3>

    <div>
    <span>
        联系方式：business@yongxintechhk.com<br/>联系地址：S8 9F W LUXE 5 ON YIU STREET SHA TIN NT HK
    </span>
    </div>

    <div id="container">
    <img
      src="../assets/contactus/img.png"
      alt
      style="width: 100%; height: 100%;"
    />
    </div>

    </div>
</template>
<style scoped>
.contact_us{
}
#container{
    width: 42.625rem;
    height:25.6875rem;
    margin-top: 3.125rem;
    margin-bottom: 3.125rem;
    display: inline-block;
}

h3 {
  padding-top: 3.125rem;
  padding-bottom: 3.125rem;
  color: #1A1A1A;
  font-size: 1.5rem;
  line-height: 36px;
}

span{
  color: #777;
  font-size:0.875rem;
  line-height:1.375rem;
}
</style>
<script>
export default {

    data () {
    return {
        msg:'联系我们'
    };
    },

    mounted () {
        // this.createImageBitmap();
    },

    methods:{
    //  createImageBitmap () {
    //     var map = new BMapGL.Map('container');
    //     var marker = new BMapGL.Marker(new BMapGL.Point(113.893496,22.556749)); // 创建点
    //     map.centerAndZoom(new BMapGL.Point(113.893496,22.556749), 17);
    //     map.enableScrollWheelZoom(true);
    //     map.addOverlay(marker);
    //  },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ContactUs.vue